import { useEffect, useState } from "react";
import {
  StyledLayoutContent,
  StyledLayoutMain,
  StyledRightPanel,
  StyledSidebarPanel,
} from "./index.styled";
import AdminSidebar from "./AdminSidebar";
import AppContentView from "../../AppContentView";
import AppRightPanel from "./AppRightPanel";
import { updateSidebar } from "@lib/redux/slices/screen";
import { updateRightPanel } from "@lib/redux/slices/screen";
import { useTypedDispatch } from "@lib/redux";
import { useTypedSelector } from "@lib/redux";
import { AppLayoutProps } from "@lib/components/AppComponents/AppLayout/Layouts";
import { AdminSidebarMenuProps } from "./AdminSidebar";

type AdminBodyProps = AppLayoutProps & {
  menuProps?: AdminSidebarMenuProps;
};

export default function AdminBody({
  children,
  routesConfig,
  menuProps,
}: AdminBodyProps) {
  const dispatch = useTypedDispatch();
  const { sidebar, header, footer, rightPanel } = useTypedSelector(
    (state) => state.screen,
  );
  const [sidebarWidth, setSidebarWidth] = useState<number | null>(null);
  const [rightPanelWidth, setRightPanelWidth] = useState<number | null>(null);
  const minusHeight = header.height + (footer.enabled ? footer.height : 0);

  useEffect(() => {
    setSidebarWidth(sidebar.width);
  }, [sidebar.width, sidebar.collapsed]);

  useEffect(() => {
    setRightPanelWidth(rightPanel.width);
  }, [rightPanel.width]);

  const handleResize = (sizes: number[]) => {
    setSidebarWidth(sizes[0]);
    setRightPanelWidth(sizes[2]);
  };

  const handleResizeEnd = (sizes: number[]) => {
    dispatch(updateSidebar({ width: sizes[0] }));
    dispatch(updateRightPanel({ width: sizes[2] }));
  };

  return (
    <StyledLayoutMain
      minusHeight={minusHeight}
      onResize={handleResize}
      onResizeEnd={handleResizeEnd}
    >
      <StyledSidebarPanel
        size={sidebarWidth}
        defaultSize={sidebar.width || sidebar.defaultWidth}
        min={sidebar.minWidth}
        max={sidebar.maxWidth}
      >
        <AdminSidebar routesConfig={routesConfig} menuProps={menuProps} />
      </StyledSidebarPanel>

      <StyledLayoutContent>
        <AppContentView children={children} minusHeight={minusHeight} />
      </StyledLayoutContent>

      {rightPanel.enabled && (
        <StyledRightPanel
          size={rightPanelWidth}
          defaultSize={rightPanel.width}
          min={rightPanel.minWidth}
          max={rightPanel.maxWidth}
        >
          <AppRightPanel />
        </StyledRightPanel>
      )}
    </StyledLayoutMain>
  );
}
